// extracted by mini-css-extract-plugin
export default {"content":"content---eNg5W"};